import { Link } from "react-router-dom"

export const Home = () => {

  return (
    <>
      <section className="bg-[#FAFAFA] py-12 px-4">
        <div className="w-full grid md:grid-cols-2 gap-8 items-center">

          <div className="space-y-6">
            <h1 className="heading-bold max-md:text-4xl text-6xl font-extrabold text-gray-900 leading-tight">
              Online Sunday School <br />
              Anytime, Anywhere
            </h1>
            <p className="text-gray-600 text-sm">
              A joyful and interactive online Sunday School experience where children learn God’s Word, grow in faith,
              and develop Christ-like character — right from home or church.
            </p>

            <Link to="/signup">
              <button className="bg-primary text-white px-8 py-[10px] mt-5 rounded-[20px] text-sm">
                Get Started
              </button>
            </Link>

            <div className="flex gap-6 flex-wrap pt-4">
              <div className="flex items-center gap-2 text-sm text-gray-700 font-semibold">
                <span className="text-white px-[4px] rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-sm">
                    check
                  </span>
                </span>
                Bible-based lessons
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700 font-semibold">
                <span className="text-white px-[4px] rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-sm">
                    check
                  </span>
                </span>
                Engaging videos & activities
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-700 font-semibold">
                <span className="text-white px-[4px] rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-sm">
                    check
                  </span>
                </span>
                Safe & easy to use
              </div>
            </div>
          </div>

          <div className="border-[6px] border-[#D9D9D9] rounded-xl">
            <img
              src="images/header-img.jpg"
              alt="Online Sunday School"
              className="w-full rounded-lg object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-10 px-8">
        <div className="w-full grid md:grid-cols-2 gap-12 items-center">

          <div className="space-y-6">
            <h2 className="heading-bold text-5xl font-bold text-gray-900">
              Why Online <br /> Sunday School?
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Children can explore the Bible, build strong faith habits, and connect with loving teachers — at a time and place that works best for families.
            </p>

            <Link to="/signup">
              <button className="bg-primary text-white px-8 py-[10px] mt-5 rounded-[20px] text-sm">
                Get Started
              </button>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-primary text-xl">
                <span className="material-symbols-outlined">
                  alarm_on
                </span>
              </div>
              <h3 className="font-bold text-lg">Flexible Time</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Families can learn the Bible at their own pace and schedule, making it easy to balance worship, school, and home life.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-primary text-xl">
                <span className="material-symbols-outlined">
                  chart_data
                </span>
              </div>
              <h3 className="font-bold text-lg">Track Progress</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Teachers and parents can monitor learning, scripture memory, and spiritual growth step-by-step.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-primary text-xl">
                <span className="material-symbols-outlined">
                  category
                </span>
              </div>
              <h3 className="font-bold text-lg">Structured Lessons</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Lessons include Bible stories, quizzes, and exercises.
              </p>
            </div>

            <div className="flex flex-col gap-3">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-primary text-xl">
                <span className="material-symbols-outlined">
                  cloud_done
                </span>
              </div>
              <h3 className="font-bold text-lg">Learn Anywhere</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Join from home, church, or travel — Bible learning is always a click away.
              </p>
            </div>
          </div>
        </div>
      </section >

      <section className="py-10 px-8">
        <div className="w-full grid md:grid-cols-2 gap-12 items-center">

          <div className="space-y-6">
            <h2 className="heading-bold text-5xl font-bold text-gray-900">
              Blessings of <br /> Faith-Based Learning
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Children discover God’s Word in a joyful, comfortable environment — whether learning at home, church, or anywhere they feel inspired.
            </p>

            <div className="space-y-5">
              <div className="flex items-center gap-3 text-sm text-gray-700 font-semibold">
                <div className="text-white w-10 h-10 flex items-center justify-center rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-lg">
                    check
                  </span>
                </div>
                Deep & Meaningful Faith Learning
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-700 font-semibold">
                <div className="text-white w-10 h-10 flex items-center justify-center rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-lg">
                    check
                  </span>
                </div>
                Spirit-Guided Lessons & Activities
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-700 font-semibold">
                <div className="text-white w-10 h-10 flex items-center justify-center rounded-full bg-primary ">
                  <span className="material-symbols-outlined text-lg">
                    check
                  </span>
                </div>
                Faith Grows Anytime, Anywhere
              </div>
            </div>
          </div>

          <div className="border-[6px] border-[#D9D9D9] rounded-[46px]">
            <img
              src="images/home-page-image-1.jpg"
              alt="Children learning God's Word"
              className="w-full rounded-[41px] object-cover"
            />
          </div>
        </div>
      </section>
    </>
  )
}